import * as React from 'react';

import { HeartFavouriteButton } from '../../components/HeartFavouriteButton';
import { NewbuildingHeaderServices } from '../../components/NewbuildingHeaderServices';
import { NewbuildingFlatTourBookingContainer } from '../NewbuildingFlatTourBooking';
import { NewbuildingHeaderBrokerButtonContainer } from '../NewbuildingHeaderBrokerButton';
import { NewbuildingHeaderCallContainer } from '../NewbuildingHeaderCall';
import { NewbuildingHeaderFavouriteButtonContainer } from '../NewbuildingHeaderFavouriteButton';

export const NewbuildingHeaderServicesContainer: React.FC = () => {
  return (
    <NewbuildingHeaderServices>
      <NewbuildingHeaderBrokerButtonContainer />
      <NewbuildingHeaderCallContainer />
      <NewbuildingFlatTourBookingContainer />
      <NewbuildingHeaderFavouriteButtonContainer button={HeartFavouriteButton} />
    </NewbuildingHeaderServices>
  );
};
